export default __webpack_public_path__ + "static/media/logo-burrito.4049a15a.png";